<main>
  <app-conciliation-header
    [confEdiary]="confEdiary"
    (confEdiaryEmit)="updateConciliationRequired($event)"
  ></app-conciliation-header>

  <!--Se muestra cuando se activa una ventana de tiempo-->
  <div class="body p-grid" *ngIf="confEdiary.isWindowsConciliationRequired">
    <div class="p-col-12 p-d-flex p-justify-between flex-container-button">
      <div class="completeInformationText">
        <p class="text-bold">
          {{
            'ediary.components.generalConfiguration.conciliation.addCompleteInformation'
              | translate
          }}
        </p>
        <small>{{
          'ediary.components.generalConfiguration.conciliation.adittionalInformation'
            | translate
        }}</small>
      </div>
      <div>
        <p-button
          id="btn_add"
          class="newWindow"
          [label]="
            'ediary.components.generalConfiguration.conciliation.addWindow'
              | translate
          "
          icon="pi pi-plus"
          styleClass="p-button-outlined"
          [disabled]="isEditionUI"
          (click)="!isEditionUI && addNewWindow()"
        ></p-button>
      </div>
    </div>

    <div class="windows p-grid p-col-12">
      <div
        class="window p-col-12 p-mb-3"
        *ngFor="let window of windows; let i = index"
      >
        <app-window-time-form
          [windowTimeForm]="window"
          [windowIndex]="i"
          [windows]="windows"
          [confDays]="confDays"
          [confForms]="confForms"
          (isWindowEditionEmit)="isEditionUI = $event"
          (skipCreationEmit)="skipCreation = $event"
          (isEnableFormEmit)="windows = $event"
          (isWindowDeletionEmit)="isDeletion = $event"
          (windowsEmit)="saveWindows($event)"
        ></app-window-time-form>
      </div>
    </div>

    <div class="noTimeWindow" *ngIf="!windows.length">
      <div class="NoTimeWindowImage">
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <rect width="80" height="80" fill="url(#pattern0)" />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlink:href="#image0_772_26783"
                transform="scale(0.0104167)"
              />
            </pattern>
            <image
              id="image0_772_26783"
              width="96"
              height="96"
              xlink:href="data:image/png;base64,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"
            />
          </defs>
        </svg>
      </div>
      <div class="noTimeWindowText">
        <p class="text-bold p-mb-3" style="font-weight: normal">
          {{
            'ediary.components.generalConfiguration.conciliation.noWindow'
              | translate
          }}
        </p>
        <p class="text-bold">
          {{
            'ediary.components.generalConfiguration.conciliation.noWindowAdd'
              | translate
          }}
        </p>
      </div>
    </div>
  </div>
</main>
